import React, { useState, useEffect } from "react";

import Erbie from "../../Assets/logo-projects/initia.jpg";
import Fleek from "../../Assets/logo-projects/artela.png";
import Q from "../../Assets/logo-projects/redbelly.jpg";
import Stader from "../../Assets/logo-projects/penumbra.jpg";
import Transformers from "../../Assets/logo-projects/Transformers.png";

function useScrollAnimation() {
  const [isVisible, setIsVisible] = useState(false);
  const ref = React.useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.1 }
    );

    const currentRef = ref.current;
    if (currentRef) observer.observe(currentRef);
    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, []);

  return [ref, isVisible];
}

function AnimatedSection({ children, className = "", delay = 0 }) {
  const [ref, isVisible] = useScrollAnimation();
  
  return (
    <div
      ref={ref}
      className={`scroll-animate ${isVisible ? "animate-in" : ""} ${className}`}
      style={{ animationDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}

function ProjectsBox() {
  const projects = [
    { img: Erbie, name: "Initia" },
    { img: Fleek, name: "Artela" },
    { img: Q, name: "Redbelly" },
    { img: Stader, name: "Penumbra" },
    { img: Transformers, name: "Transformers" },
  ];

  return (
    <div className="projects-grid-container">
      {projects.map((project, index) => (
        <AnimatedSection key={index} delay={index * 100}>
          <a
            href={project.url || "#"}
            target={project.url ? "_blank" : undefined}
            rel={project.url ? "noreferrer" : undefined}
            className="project-item"
            style={{ textDecoration: "none" }}
          >
            <div className="project-status">
              <span className="status-dot pulse"></span>
            </div>
            <div className="project-logo-card">
              <img src={project.img} className="logo" alt={project.name} />
            </div>
            <span className="project-name">{project.name}</span>
            {project.isNew && (
              <span style={{ fontSize: "0.72rem", color: "#c770f0" }}>NEW</span>
            )}
          </a>
        </AnimatedSection>
      ))}
    </div>
  );
}

export default ProjectsBox;
